var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79454 0.455444C7.35509 0.0159912 6.64142 0.0159912 6.20197 0.455444L0.576965 6.08044C0.137512 6.5199 0.137512 7.23357 0.576965 7.67302C1.01642 8.11248 1.73009 8.11248 2.16954 7.67302L5.87501 3.96404V14.75C5.87501 15.3722 6.37775 15.875 7.00001 15.875C7.62228 15.875 8.12501 15.3722 8.12501 14.75V3.96404L11.8305 7.66951C12.2699 8.10896 12.9836 8.10896 13.4231 7.66951C13.8625 7.23005 13.8625 6.51638 13.4231 6.07693L7.79806 0.451929L7.79454 0.455444Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowTop);
export default __webpack_public_path__ + "static/media/icon-arrow-top.6a168290938c0b6ed0953558c0060890.svg";
export { ForwardRef as ReactComponent };